var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPerson2Filled(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Person"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\xF0\x9F\x8E\xA8 Color",
    d: "M14.7948 11.6666C15.8298 11.6666 16.6689 12.5057 16.6689 13.5407V14.3061C16.6689 14.7839 16.5195 15.2497 16.2417 15.6385C14.9535 17.4412 12.8499 18.3342 9.99965 18.3342C7.14885 18.3342 5.04638 17.4408 3.76124 15.6372C3.48461 15.2489 3.33594 14.784 3.33594 14.3073V13.5407C3.33594 12.5057 4.17498 11.6666 5.21 11.6666H14.7948ZM9.99965 1.67053C12.3008 1.67053 14.1663 3.53601 14.1663 5.8372C14.1663 8.13839 12.3008 10.0039 9.99965 10.0039C7.69847 10.0039 5.83299 8.13839 5.83299 5.8372C5.83299 3.53601 7.69847 1.67053 9.99965 1.67053Z",
    fill: "#1D72E9"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPerson2Filled);
export default __webpack_public_path__ + "static/media/person2-filled.e18193cebc7595ab25ec50decf3d9146.svg";
export { ForwardRef as ReactComponent };